import { InfoIcon } from '@/src/assets/icons'
import { appColors } from '@/src/theme/foundations/colors'
import { Box, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export const PasteHintBadge = () => {
  const { t } = useTranslation()
  return (
    <Box
      p='4px 8px'
      borderRadius='6px'
      border={`1px solid ${appColors.blue[200]}`}
      backgroundColor={'transparent'}
      h='26px'
      w='min-content'
      maxW='full'
    >
      <Flex color={appColors.info} h='full' justifyContent='center' alignItems='center' gap='4px'>
        <InfoIcon size='12px' fontSize='12px' />
        <Text fontWeight={400} fontSize='10px' isTruncated>
          {t('data_management.paste_hint')}
        </Text>
      </Flex>
    </Box>
  )
}
